// extracted by mini-css-extract-plugin
export default {"names":"NamesList_names__H6ZqO"};